import { NgModule } from '@angular/core';
import { ScProgressiveFormContainerComponent } from '@innogy/shared/progressive-form/sitecore';
import {
  GenericFormContainerComponent,
  SitecoreFormsModule,
} from '@innogy/sitecore-forms';
import { provideLazyLoad } from '@core/jss-utils';

@NgModule({
  imports: [
    SitecoreFormsModule,
    provideLazyLoad({
      GenericForm: GenericFormContainerComponent,
      ProgressiveForm: ScProgressiveFormContainerComponent,
    }),
  ],
})
export class SitecoreFormsLazyModule {}
